import { Platform } from "./types";
import { mapPlatformStatus, statusPill } from "./status";

// The dock only matters while the platform is heading to it or sitting at it.
const DOCK_BOUND = ["In Transit", "At Dock"];

export function PlatformStatusPill({ platform }: { platform: Platform }) {
  const label = mapPlatformStatus(platform.status);
  const dock = DOCK_BOUND.includes(label) ? platform.dockName : null;
  const p = statusPill(label);
  return (
    <span
      style={{
        display: "inline-flex",
        flexDirection: "column",
        alignItems: "center",
        background: p.bg,
        color: p.text,
        border: `1px solid ${p.border}`,
        fontSize: 11,
        fontWeight: 700,
        padding: dock ? "3px 12px" : "2px 10px",
        borderRadius: dock ? 10 : 999,
        textTransform: "uppercase",
        letterSpacing: "0.04em",
        whiteSpace: "nowrap",
        lineHeight: 1.3,
      }}
    >
      {dock ? `${label}:` : label}
      {dock && <span>{dock}</span>}
    </span>
  );
}
